<!--  -->
<template>
  <div class="icomposite-page">
    <screen-panel :isExpand="isOpen" class="panel">
      <screen-box title="月度碳排放趋势(tCO2e)">
        <CarbonEmssionTrendByMonths></CarbonEmssionTrendByMonths>
        <!-- <PeopleTypePie
          :personTypeData="personTypeData"
          style="margin-top: 10px"
        ></PeopleTypePie> -->
      </screen-box>
      <screen-box title="Top10用电碳排放量">
        <!-- <CarbonEmssionTrendByMonths
          style="margin-top: 10px"
        ></CarbonEmssionTrendByMonths> -->
        <CarbonEmssionByTop :topNum="10"></CarbonEmssionByTop>

        <!-- <CarbonEmssionByTop></CarbonEmssionByTop> -->
      </screen-box>
    </screen-panel>

    <screen-panel :isExpand="isOpen" position="right" class="panel">
      <screen-box title="累计碳排放(tCO2e)" height="33.3%">
        <CarbonEmssionStatics></CarbonEmssionStatics>
      </screen-box>
      <screen-box title="各建筑碳排放量(tCO2e)" height="33.3%">
        <CarbonEmssionByBuild></CarbonEmssionByBuild>
        <!-- <CarbonEmssionTrendByYear
          style="margin-top: 10px"
        ></CarbonEmssionTrendByYear> -->
      </screen-box>
      <screen-box title="年度碳排放趋势(tCO2e)" height="33.3%">
        <CarbonEmssionTrendByYear></CarbonEmssionTrendByYear>
      </screen-box>
    </screen-panel>
  </div>
</template>

<script>
import screenPanel from "../components/ScreenPanel.vue";
import ScreenBox from "../components/ScreenBox.vue";
import CarbonEmssionByTop from "../components/CarbonEmssionByTop";

// import PeopleTypePie from "../components/PersonTypePie";
// import CarbonEmssionByTop from "../components/CarbonEmssionByTop";
import CarbonEmssionTrendByYear from "../components/CarbonEmssionTrendByYear";
import CarbonEmssionByBuild from "../components/CarbonEmssionByBuild";
import CarbonEmssionTrendByMonths from "../components/CarbonEmssionTrendByMonths";
import CarbonEmssionStatics from "../components/CarbonEmssionStatics";
import API from "../api/index";
export default {
  data() {
    return {
      personTypeData: {},
      isOpen: false,
      tableDatas: [],
      columnDatas: [
        {
          label: "序号",
          prop: "index",
          width: 60,
        },
        {
          label: "区域名称",
          prop: "buildName",
        },
        {
          label: "能耗总量",
          prop: "energyQuantity",
          width: 160,
        },
        {
          label: "碳排总量",
          prop: "carbonEmission",
        },
      ],
    };
  },

  components: {
    screenPanel,
    ScreenBox,
    CarbonEmssionByTop,
    CarbonEmssionByBuild,
    // PeopleTypePie,
    // CarbonEmssionByTop,
    CarbonEmssionTrendByMonths,
    CarbonEmssionTrendByYear,
    CarbonEmssionStatics,
  },

  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.$map.showMap2D();
    this.isOpen = true;
    this.queryData();
    this.personTypeData = {
      workNum: 3258,
      visitorNum: 175,
      safeNum: 247,
      cleanNum: 149,
    };
    this.$fetch(API.carbonByBuild).then((res) => {
      if (res.success) {
        const arr = res.returnObj ? res.returnObj : []
        if (arr.length > 0) {
          const polygonData = arr.map(v => {
            return {
              label: v.buildName,
              carbonEmission: v.carbonEmission,
              id: v.buildId,
              coord: JSON.parse(v.location).coord,
              longitude: JSON.parse(v.location).longitude,
              latitude: JSON.parse(v.location).latitude,
            }
          })
          this.$map.MapInstance2D.addScreenPolygon({
            layerId: 'polygon',
            fillColor: 'rgba(0, 0, 0, 0)',
            strokeColor: 'rgba(0, 0, 0, 0)',
            polygonData,
            click: (e) => {
              let markerInfo = e.marker;
              // 挂载在vue实例上
              this.$map.MapInstance2D.addPopupMap({
                offset: [0, 0],
                position: [markerInfo.longitude, markerInfo.latitude],
                content: '<div id="polygon_popup"></div>',
                contentId: 'polygon_popup',
                layerId: 'polygon_popup',
              });
              let tipVue = new this.$map.MapInstance2D.vueComponents.polygonTip().$mount(
                "#polygon_popup"
              );
              tipVue.data = markerInfo
              tipVue.$on("tipClose", (e) => {
                this.$map.MapInstance2D.removePopup('polygon_popup');
              });
            }
          })
        }
      }
    });

    const polygonData = [
      {
        id: '0',
        label: '综合楼',
        coord: [
          [
            [117.844525, 39.190100],
            [117.844539, 39.190080],
            [117.844503, 39.190064],
            [117.844580, 39.189943],
            [117.845223, 39.190202],
            [117.845217, 39.190211],
            [117.845230, 39.190218],
            [117.845183, 39.190292],
            [117.845134, 39.190341],
          ]
        ]
      }, {
        id: '1',
        label: '厂房1',
        coord: [
          [
            [117.843958, 39.190732],
            [117.844344, 39.190131],
            [117.845095, 39.190432],
            [117.844876, 39.190781],
            [117.844985, 39.190827],
            [117.844825, 39.191072],
          ]
        ]
      }, {
        id: '2',
        label: '厂房2',
        coord: [
          [
            [117.844952, 39.191119],
            [117.845468, 39.190316],
            [117.846335, 39.190660],
            [117.845822, 39.191464]
          ]
        ]
      }, {
        id: '3',
        label: '厂房3',
        coord: [
          [
            [117.845946, 39.191513],
            [117.846463, 39.190711],
            [117.847331, 39.191055],
            [117.846817, 39.191855]
          ]
        ]
      }, {
        id: '4',
        label: '厂房4',
        coord: [
          [
            [117.843167, 39.191961],
            [117.843681, 39.191161],
            [117.844552, 39.191499],
            [117.844036, 39.192309]
          ]
        ]
      }, {
        id: '5',
        label: '厂房5',
        coord: [
          [
            [117.844163, 39.192357],
            [117.844674, 39.191555],
            [117.845542, 39.191898],
            [117.845027, 39.192702]
          ]
        ]
      }, {
        id: '6',
        label: '厂房6',
        coord: [
          [
            [117.845154, 39.192751],
            [117.845669, 39.191948],
            [117.846538, 39.192291],
            [117.846022, 39.193091]
          ]
        ]
      }]

  },

  methods: {
    queryData() {
      this.$fetch(API.carbonByDay, { pageSize: 5, pageNum: 1 }).then((res) => {
        if (res.success) {
          if (res.returnObj.length && res.returnObj.length < 10) {
            this.tableDatas = res.returnObj;
          } else if (res.returnObj.length && res.returnObj.length > 10) {
            this.tableDatas = res.returnObj.splice(0, 10);
          }
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.panel {
  height: 100%;
}
</style>
